import axios from 'axios';

const config = require('../../../config/config.js');
const { domain, header, headerFile } = config;

export default {
  async load(data) {
    let result = false;
    const url = domain + '/chat/all';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
  async loadOne(data) {
    let result = false;
    const url = domain + '/chat/one';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
  async send(data) {
    let result = false;
    const url = domain + '/chat/send';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
  async create(data) {
    let result = false;
    const url = domain + '/chat/create';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
  async unreadMessage(data) {
    let result = false;
    const url = domain + '/chat/unread-message';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
  async loadNotification(data) {
    let result = false;
    const url = domain + '/notification/load-notification';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
  async markSeen(data) {
    let result = false;
    const url = domain + '/notification/mark-seen';

    if (data !== undefined && data !== null && data !== '') {
      result = await axios.post(url, data, header);
    }

    return result;
  },
};
